import { Observable } from "rxjs";
import { Injectable, Output, EventEmitter } from "@angular/core";
import { Headers, Http, RequestOptions, Response } from "@angular/http";
import { HttpClient } from '@angular/common/http';
import { User } from "../_models";
import { environment } from "../../../environments/environment";

@Injectable()
export class UserService {
    private static _access: any = [];
    private static _user: any = null;
    private static _token: string = "";

    @Output() loggedIn: EventEmitter<boolean> = new EventEmitter();

    constructor(private http: Http, private httpClient: HttpClient) {
        const tmp = localStorage.getItem('currentUser');
        if (tmp) {
            const user = JSON.parse(tmp);
            UserService._user = user;
            UserService._token = user.token;
        }
    }

    static getUser() {
        if (!UserService._user) {
            const tmp = localStorage.getItem('currentUser');
            if (tmp) {
                const user = JSON.parse(tmp);
                UserService._user = user;
                UserService._token = user.token;
            }
        }
        return UserService._user;
    }

    static getToken() {
        if (!UserService._token) {
            const tmp = localStorage.getItem('currentUser');
            if (tmp) {
                const user = JSON.parse(tmp);
                UserService._user = user;
                UserService._token = user.token;
            }
        }
        return UserService._token;
    }

    static getAccess(action?: string) {
        if (!UserService._access.length) {
            const tmp = localStorage.getItem('level');
            if (tmp) {
                UserService._access = JSON.parse(tmp);
            }
        }
        if (action) {
            return UserService._access.find(e => e.action_id == action);
        }
        return UserService._access;
    }

    login(email: string, password: string) {
        return new Observable(obs => {
            this.httpClient.post(environment.server + '/users/login', { userid: email, password: password })
                .subscribe(
                    (result: any) => {
                        if (!environment.production) console.info(result);
                        // login successful if there's a jwt token in the response
                        if (result.results instanceof Array && result.results.length) {
                            const user = result.results[0];
                            const level = result.level;
                            console.info("level", level);
                            if (user && user.token) {
                                // store user details and jwt token in local storage to keep user logged in between page refreshes
                                UserService._user = user;
                                UserService._token = user.token;
                                UserService._access = level;

                                localStorage.setItem('currentUser', JSON.stringify(user));
                                localStorage.setItem('level', JSON.stringify(level));

                                $('.j-username').text(user.firstname);
                                $('.j-useremail').text(user.userid);

                                this.loggedIn.emit(true);

                                obs.next(user);
                                obs.complete();
                            }
                        } else {
                            obs.error("Login error.");
                        }
                    },
                    error => {
                        obs.error(error);
                    });
        });
    }

    logout() {
        localStorage.removeItem('currentUser');
        localStorage.removeItem('level');
        UserService._access.length = 0;
        UserService._token = "";
        UserService._user = null;

        this.loggedIn.emit(false);
    }

    verify() {
        return this.http.get('/api/verify', this.jwt()).map((response: Response) => response.json());
    }

    forgotPassword(email: string) {
        return this.httpClient.post(environment.server + '/users/password/reset', { userId: email }).map((response: Response) => { return true; });
    }

    getAll() {
        return this.http.get('/api/users', this.jwt()).map((response: Response) => response.json());
    }

    getById(id: number) {
        return this.http.get('/api/users/' + id, this.jwt()).map((response: Response) => response.json());
    }

    // create(user: User) {
    //     return this.http.post('/api/users', user, this.jwt()).map((response: Response) => response.json());
    // }

    create(user: User) {
        if (!environment.production) console.info(user);
        // let tmp = { remember: true, firstname: "asd", lastname: "asd", email: "asd@mail.com", telno: "0000", password: "asd", rpassword: "asd" }
        let data: any = Object.assign({}, user);
        data.userid = user.email;
        data.lastname = '';
        data.address = '';

        return this.httpClient.post(environment.server + '/users/register', data).map(
            (result: any) => { return null; });
    }

    update(user: User) {
        return this.http.put('/api/users/' + user.id, user, this.jwt()).map((response: Response) => response.json());
    }

    delete(id: number) {
        return this.http.delete('/api/users/' + id, this.jwt()).map((response: Response) => response.json());
    }

    // private helper methods

    private jwt() {
        // create authorization header with jwt token
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (currentUser && currentUser.token) {
            let headers = new Headers({ 'Authorization': 'Bearer ' + currentUser.token });
            return new RequestOptions({ headers: headers });
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/auth/_services/user.service.ts